import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { MinusCircleOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Form, Select, Input, InputNumber, Divider, Button, Alert, DatePicker, Tooltip, Space } from 'antd';
import EmployeeSearchBox from '../../../Components/EmployeeSearchBox';
import { loopThroughCurrentMonthDays } from '../../Helper';

const { Option } = Select;

const DPRForm = ({ disabled, isVendorForm, fetchDependentDropdownValues, putDecimalLimit, ...props }) => {
    const [name, setName] = useState('');
    const addButton = React.createRef();

    useEffect(() => {
        if (!props['isInEdit']) {
            addButton.current.click();
        }
    }, []);

    const onNameChange = (event) => {
        setName(event.target.value);
    };

    const addItem = (e, field) => {
        e.preventDefault();
        if (field === 'area') {
            props['setMstArea']([...props['area'], {'area_id': name, 'area_name': name}]);
        } else {
            props['setMstSubArea']([...props['subArea'], {'id': name, 'sub_area': name}]);
        }
        setName('');
    };

    const disabledDate = (current, backendDate) => {
        if (!current || !backendDate) {
            return false;
        }

        const backendMoment = moment(backendDate);
        const currentMoment = moment();

        const currentMonth = current.month();
        const currentYear = current.year();
        const backendMonth = backendMoment.month();
        const backendYear = backendMoment.year();

        const fifteenDaysAgo = currentMoment.clone().subtract(15, 'days').startOf('day');

        // // Disable dates in all months except the previous and current month (relative to backendDate)
        // if (
        //   (currentYear < backendYear) ||
        //   (currentYear === backendYear && currentMonth < backendMonth) ||
        //   (currentYear > backendYear) ||
        //   (currentYear === backendYear && currentMonth > backendMonth)
        // ) {
        //   return true;
        // }

        // if (currentYear === currentMoment.year() && currentMonth === currentMoment.month() && current.isBefore(fifteenDaysAgo, 'day')) {
        //     return true;
        // }

        if (currentYear === backendYear && currentMonth === backendMonth && current.isBefore(currentMoment, 'day')) {
            return false;
        }

        // if (current.isAfter(currentMoment, 'day')) {
        //     return true;
        // }

        return true;
    };

    const numberofDays = loopThroughCurrentMonthDays(props['isInEdit'], props['activityMonth']);

    return (
        <>
        {/* {
            (!props['vendorInputsSubmitted'] && props['isInEdit']) &&
            <Alert style={{margin: "10px"}} message="Input for the day is pending" type="warning" showIcon />
        } */}
        <div className="row form-box" style={{paddingTop:"10px"}}>
            {
                isVendorForm &&
                <>
                    <div className="col-lg-6 col-md-12">
                        <Form.Item
                            name="vendor_activity"
                            label="Activity"
                            rules={[{ required: true, message: 'Please select activity' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select activity"
                                optionFilterProp="children"
                            >
                                {props['activityList'].map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.activity_name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <Form.Item
                            name="input_date"
                            label="Input Date"
                            rules={[{ required: true, message: 'Please select date' }]}
                        >
                            <DatePicker style={{ width: "100%" }} disabledDate={(current) => disabledDate(current, props['createdDate'])} />
                        </Form.Item>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <Form.Item
                            name="actual_for_day"
                            label="Actual for the day"
                            rules={[{ required: true, message: 'Please input values' }]}
                            initialValue={0}
                        >
                            <InputNumber
                                style={{ width: "100%" }}
                                placeholder={"Input actual values for day"}
                                // disabled={props['vendorInputsSubmitted']}
                                min={0}
                            />
                        </Form.Item>
                    </div>

                    <div className="col-lg-6 col-md-12" style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                        <Button
                            htmlType="submit"
                            type="primary">Submit
                        </Button>
                    </div>
                    
                    <Divider />
                </>
            }

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="location"
                    label="Location"
                    rules={[{ required: true, message: 'Please select location' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select location"
                        optionFilterProp="children"
                        disabled={disabled}
                        onSelect={(value) => fetchDependentDropdownValues('MstProgram', 'location.location_id=', value)}
                    >
                        {props['location'].map((item) => (
                            <Option key={item.location_id} value={item.location_id}>
                                {item.location_name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="stream"
                    label="Stream"
                    rules={[{ required: true, message: 'Please select stream' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select stream"
                        optionFilterProp="children"
                        disabled={disabled}
                        onSelect={(value) => fetchDependentDropdownValues('MstProject', 'program.program_id=', value)}
                    >
                        {props['program'].map((item) => (
                            <Option key={item.program_id} value={item.program_id}>
                                {item.program_name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="project"
                    label="Project"
                    rules={[{ required: true, message: 'Please select project' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select project"
                        optionFilterProp="children"
                        disabled={disabled}
                    >
                        {props['project'].map((item) => (
                            <Option key={item.project_id} value={item.project_id}>
                                {item.project_name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="area"
                    label="Area"
                    // rules={[{ required: true, message: 'Please input area' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select area"
                        optionFilterProp="children"
                        disabled={disabled}
                        onSelect={(key, value) => fetchDependentDropdownValues('MstSubArea', 'area.area_id=', value.key)}
                        dropdownRender={(menu) => (
                            <>
                                {menu}
                                <Divider
                                    style={{
                                    margin: '8px 0',
                                    }}
                                />
                                <Space
                                    style={{
                                      padding: '0 8px 4px',
                                    }}
                                >
                                    <Input
                                      placeholder="Please enter item"
                                      // ref={inputRef}
                                      value={name}
                                      onChange={onNameChange}
                                    />
                                    <Button type="text" icon={<PlusOutlined />} onClick={(e) => addItem(e, 'area')}>
                                        Add item
                                    </Button>
                                </Space>
                            </>
                        )}
                    >
                        {props['area'].map((item) => (
                            <Option key={item.area_id} value={item.area_id}>
                                {item.area_name}
                            </Option>
                        ))}
                    </Select>
                    {/*<Input disabled={disabled} placeholder={"Input area"} maxLength={100} />*/}
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="sub_area"
                    label="Sub Area"
                    // rules={[{ required: true, message: 'Please input sub area' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select sub area"
                        optionFilterProp="children"
                        disabled={disabled}
                        dropdownRender={(menu) => (
                            <>
                                {menu}
                                <Divider
                                    style={{
                                    margin: '8px 0',
                                    }}
                                />
                                <Space
                                    style={{
                                      padding: '0 8px 4px',
                                    }}
                                >
                                    <Input
                                      placeholder="Please enter item"
                                      // ref={inputRef}
                                      value={name}
                                      onChange={onNameChange}
                                    />
                                    <Button type="text" icon={<PlusOutlined />} onClick={(e) => addItem(e, 'subArea')}>
                                        Add item
                                    </Button>
                                </Space>
                            </>
                        )}
                    >
                        {props['subArea'].map((item) => (
                            <Option key={item.id} value={item.id}>
                                {item.sub_area}
                            </Option>
                        ))}
                    </Select>
                    {/*<Input disabled={disabled} placeholder={"Input sub area"} maxLength={200}/>*/}
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="contractor"
                    label="Contractor"
                    rules={[{ required: true, message: 'Please select contractor' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select contractor"
                        optionFilterProp="children"
                        disabled={disabled}
                        onChange={props['onChangeContractor']}
                    >
                        {props['contractor'].map((item) => (
                            <Option key={item.code} value={item.code}>
                                {`${item.display_name} (${item.code})` }
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="contractor_email"
                    label="Contractor Email"
                    rules={[{type: 'email'}, { required: true, message: 'Please enter contractor email' }]}
                >
                    <Input disabled={disabled} placeholder={"Input contractor email"} maxLength={254} />
                </Form.Item>
            </div>
        </div>

        <Form.List name="activity_list">
            {(fields, { add, remove }) => (
            <>
            {fields.map(({ key, name, ...restField }) => (
                <>
                    <div className="row form-box">
                        <legend className="form-legend" style={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <div>
                                Activity Details - {name + 1}
                            </div>
                            <div style={{display: "flex", justifyContent: "right", alignItems: "center"}}>
                            {
                                props['isInEdit'] &&
                                <Button
                                    type='primary'
                                    shape='round'
                                    style={{ marginRight: "10px" }}
                                    onClick={() => props['showVendorInputs'](key, name, restField)}
                                >
                                    Vendor Inputs
                                </Button>
                            }
                            {
                                !isVendorForm &&
                                <Tooltip title="Delete">
                                    <DeleteOutlined style={{ fontSize: '20px', color: 'red' }} onClick={() => remove(name)} />
                                </Tooltip>
                            }
                            </div>
                        </legend>
                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "activity"]}
                                label="Activity"
                                rules={[{ required: true, message: 'Please input activity' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select activity"
                                    optionFilterProp="children"
                                    disabled={disabled}
                                    onChange={(e) => props['onChangeActivity'](e, name)}
                                >
                                    {props['activity'].map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.activity}
                                        </Option>
                                    ))}
                                </Select>
                                {/* <Input disabled={disabled} placeholder={"Input activity"} maxLength={200} /> */}
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "measurement_unit"]}
                                label="UoM"
                                rules={[{ required: true, message: 'Please input measurement unit' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select unit"
                                    optionFilterProp="children"
                                    disabled={true}
                                >
                                    {props['unit'].map((item) => (
                                        <Option key={item.unit_id} value={item.unit_id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                                {/* <Input disabled={disabled} placeholder={"Input measurement unit"} maxLength={10} /> */}
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "scope"]}
                                label="Scope"
                                rules={[{ required: true, message: 'Please input scope' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input scope"}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "previous_month_completion"]}
                                label="Completed till Previous Month"
                                rules={[{ required: true, message: 'Please input Completed till Previous Month' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input completed till previous month"}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "drawing_availability"]}
                                label="Drawing Availability"
                                // rules={[{ required: true, message: 'Please input drawing availability' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input drawing availability"}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "front_availability"]}
                                label="Front Availability"
                                // rules={[{ required: true, message: 'Please input front availability' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input front availability"}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "amns_supervisor"]}
                                label="AMNS Supervisor"
                            >
                                <EmployeeSearchBox
                                    isFormList
                                    formRef={props['formRef']}
                                    mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                                    decorator={[name, "amns_supervisor"]}
                                    disabled={disabled}
                                    placeholder="Enter AMNS supervisor"
                                    formListDecorator={"activity_list"}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "contractor_supervisor"]}
                                label="Contractor Supervisor"
                            >
                                <Input
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input contractor supervisor"}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <Form.Item
                                name={[name, "oig_representative"]}
                                label="OIG Representative"
                            >
                                <EmployeeSearchBox
                                    isFormList
                                    formRef={props['formRef']}
                                    mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                                    decorator={[name, "oig_representative"]}
                                    disabled={disabled}
                                    placeholder="Enter OIG Representative"
                                    formListDecorator={"activity_list"}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-12 col-md-12">
                            <Button
                                onClick={() => props['fetchScope'](name)}
                                shape={"round"}
                                style={{ float: "right" }}
                                type="primary">{"Get Scope"}
                            </Button>
                        </div>

                        <Divider />
                    {/* </div> */}

                    {
                        numberofDays.map(data => 
                            <div style={{ display: "flex", justifyContent: "space-between", marginLeft: "15px" }}>
                                <Form.Item
                                    name={[name, `plan_${data['dateValue']}`]}
                                    label={`${data['formattedDate']}`}
                                    rules={[{ required: true, message: '' }]}
                                    initialValue={0}
                                >
                                    <InputNumber
                                        min={0}
                                        disabled={disabled}
                                        onChange={() => props['setMonthlyPlan'](name)}
                                        parser={value => putDecimalLimit(value)}
                                    />
                                </Form.Item>
                            </div>
                        )
                    }

                    {/* <div className="row form-box" style={{paddingTop:"10px"}}> */}

                        {/* <div className="col-lg-2 col-md-12">
                            <Form.Item
                                name={[name, "plan_week_1"]}
                                label="Weekly 1 Plan"
                                rules={[{ required: true, message: 'Please input week 1 plan' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input week 1 plan"}
                                    onChange={() => props['setMonthlyPlan'](name)}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-2 col-md-12">
                            <Form.Item
                                name={[name, "plan_week_2"]}
                                label="Weekly 2 Plan"
                                rules={[{ required: true, message: 'Please input week 2 plan' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input week 2 plan"}
                                    onChange={() => props['setMonthlyPlan'](name)}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-2 col-md-12">
                            <Form.Item
                                name={[name, "plan_week_3"]}
                                label="Weekly 3 Plan"
                                rules={[{ required: true, message: 'Please input week 3 plan' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input week 3 plan"}
                                    onChange={() => props['setMonthlyPlan'](name)}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div> 

                        <div className="col-lg-2 col-md-12">
                            <Form.Item
                                name={[name, "plan_week_4"]}
                                label="Weekly 4 Plan"
                                rules={[{ required: true, message: 'Please input week 4 plan' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input week 4 plan"}
                                    onChange={() => props['setMonthlyPlan'](name)}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-2 col-md-12">
                            <Form.Item
                                name={[name, "plan_week_5"]}
                                label="Weekly 5 Plan"
                                initialValue={0}
                                // rules={[{ required: true, message: 'Please input week 5 plan' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={disabled}
                                    style={{ width: "100%" }}
                                    placeholder={"Input week 5 plan"}
                                    onChange={() => props['setMonthlyPlan'](name)}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-2 col-md-12">
                            <Form.Item
                                name={[name, "monthly_plan"]}
                                label="Monthly Plan"
                                rules={[{ required: true, message: 'Please input monthly plan' }]}
                            >
                                <InputNumber
                                    min={0}
                                    disabled={true}
                                    style={{ width: "100%" }}
                                    placeholder={"Input monthly plan"}
                                    parser={value => putDecimalLimit(value)}
                                />
                            </Form.Item>
                        </div> */}

                        {
                            props['isInEdit'] &&
                            <>
                                <div className="col-lg-2 col-md-12">
                                    <Form.Item
                                        name={[name, "monthly_plan"]}
                                        label="Monthly Plan"
                                    >
                                        <InputNumber disabled={true} style={{ width: "100%" }} />
                                    </Form.Item>
                                </div>
                                <Divider />
                                <div className="col-lg-2 col-md-12">
                                    <Form.Item
                                        name={[name, "actual_day"]}
                                        label="Actual for day"
                                    >
                                        <InputNumber disabled={true} style={{ width: "100%" }} />
                                    </Form.Item>
                                </div>

                                <div className="col-lg-2 col-md-12">
                                    <Form.Item
                                        name={[name, "completed_ftm"]}
                                        label="Completed FTM"
                                    >
                                        <InputNumber disabled={true} style={{ width: "100%" }} />
                                    </Form.Item>
                                </div>

                                <div className="col-lg-2 col-md-12">
                                    <Form.Item
                                        name={[name, "balance_ftm"]}
                                        label="Balance FTM"
                                    >
                                        <InputNumber disabled={true} style={{ width: "100%" }} />
                                    </Form.Item>
                                </div>

                                <div className="col-lg-2 col-md-12">
                                    <Form.Item
                                        name={[name, "asking_rate_ftm"]}
                                        label="Asking Rate FTM"
                                    >
                                        <InputNumber disabled={true} style={{ width: "100%" }} />
                                    </Form.Item>
                                </div>

                                <div className="col-lg-2 col-md-12">
                                    <Form.Item
                                        name={[name, "completed_till_date"]}
                                        label="Completed Till Date"
                                    >
                                        <InputNumber disabled={true} style={{ width: "100%" }} />
                                    </Form.Item>
                                </div>

                                <div className="col-lg-2 col-md-12">
                                    <Form.Item
                                        name={[name, "balance_scope"]}
                                        label="Balance Scope"
                                    >
                                        <InputNumber disabled={true} style={{ width: "100%" }} />
                                    </Form.Item>
                                </div>
                            </>
                        }
                    </div>
                </>
            ))}
            {
                !props['isInEdit'] &&
                <Form.Item style={{ marginRight: "10px", marginLeft: "10px" }}>
                    <Button ref={addButton} style={{ height: "40px" }} type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                        Add New Activity
                    </Button>
                </Form.Item>
            }
            </>
            )}
        </Form.List>
        </>
    )
}

export default DPRForm;
